import { Box, Typography } from "@mui/material";
import React, { useState, useRef } from "react";
import { palette } from "../themes/theme";

const DragAndDropFileUpload = ({
  onFileUpload,
  acceptedFormats = ".jpg,.jpeg,.png,.svg",
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const inputRef = useRef(null);

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      onFileUpload(files);
    }
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleFileChange = (e) => {
    if (e.target.files) {
      onFileUpload(e.target.files);
    }
  };

  return (
    <Box
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      onClick={handleClick}
      sx={{
        width: "100%",
        background: palette.background.light,
        border: `1px solid ${palette.primary.main}`,
        borderRadius: 2,
        textAlign: "center",
        cursor: "pointer",
        height: "inherit",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      {isDragging ? (
        <Typography sx={{ color: palette.text.dark }}>
          Drop the files here...
        </Typography>
      ) : (
        <Typography sx={{ color: palette.text.dark }}>
          Drag and Drop <br /> or <br />{" "}
          <span
            style={{ color: palette.primary.main, textDecoration: "underline" }}
          >
            Browse File
          </span>
        </Typography>
      )}
      <input
        ref={inputRef}
        type="file"
        accept={acceptedFormats}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </Box>
  );
};

export default DragAndDropFileUpload;
